// src/components/reader/NextLessonCard.jsx
//
// The end of a lesson (lesson-3b-feedback): either the next lesson, or the fact that
// there isn't one. It closes the loop -- learn, drill, mark, and then a visible way
// onward instead of a scroll into nothing.
//
// `next` is a nextContentEntry() result ({ id, title, groupKey }); null means the
// student has reached the end of the unit.
import React from 'react';
import LessonCard from './LessonCard.jsx';
import { readingMinutes } from './lessonMeta.js';

export default function NextLessonCard({ next, blocksFor, onGo }) {
    if (!next) {
        return (
            <LessonCard className="mt-10 text-center">
                <div className="font-display text-book-accent text-xs font-semibold mb-1">Unit complete</div>
                <p className="font-serif italic text-book-muted text-sm">You&rsquo;ve finished this unit.</p>
            </LessonCard>
        );
    }

    // The minutes come from the NEXT section's own blocks when the caller can supply
    // them; a caller that cannot (or a section with no blocks) simply omits the line
    // rather than printing a made-up number.
    const blocks = typeof blocksFor === 'function' ? blocksFor(next.id) : null;
    const minutes = blocks ? readingMinutes(blocks) : null;

    return (
        <LessonCard className="mt-10">
            <div className="font-display text-book-muted text-xs font-semibold mb-1">Next</div>
            <div className="flex items-center justify-between gap-4 flex-wrap">
                <div className="min-w-0">
                    <div className="font-display text-book-text text-base font-bold leading-tight [overflow-wrap:anywhere]">{next.title}</div>
                    {minutes != null && (
                        <div className="font-display text-book-muted text-xs mt-0.5">~{minutes} min read</div>
                    )}
                </div>
                <button type="button" onClick={() => onGo(next)}
                    className="flex-shrink-0 px-4 py-2 rounded-full bg-book-accent text-book-pageDark font-display text-sm font-semibold">
                    Start
                </button>
            </div>
        </LessonCard>
    );
}
